import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { THEME } from './lib/config';

// Apply theme before first render to avoid flash
document.documentElement.setAttribute('data-theme', THEME);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
